import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  title: {
    id: 'portal.views.registration.title',
    defaultMessage: 'Create an Account',
    description: 'Title of the Registration form',
  },
  description: {
    id: 'portal.views.registration.description',
    defaultMessage: 'Email verification may be required.',
    description: 'Description of the Registration form',
  },
  emailFieldPlaceholder: {
    id: 'portal.views.registration.field.email.placeholder',
    defaultMessage: 'Email address',
    description: 'Email field placeholder',
  },
  emailFieldHelpText: {
    id: 'portal.views.registration.field.email.helper.text',
    defaultMessage: 'e.g. amazingteacher@example.com',
    description: 'Helper text for email field',
  },
  usernameFieldHelpText: {
    id: 'portal.views.registration.field.username.helper.text',
    defaultMessage: 'e.g. amazingteacher',
    description: 'Helper text for username field',
  },
  usernameFieldPlaceholder: {
    id: 'portal.views.registration.field.username.placeholder',
    defaultMessage: 'Username',
    description: 'Username field placeholder',
  },
  passwordFieldPlaceholder: {
    id: 'portal.views.registration.field.password.placeholder',
    defaultMessage: 'Password',
    description: 'Password field placeholder',
  },
  confirmPasswordFieldPlaceholder: {
    id: 'portal.views.registration.field.confirmPassword.placeholder',
    defaultMessage: 'Confirm password',
    description: 'Placeholder for confirm password field',
  },
  honorCodeCheckboxLabel: {
    id: 'portal.views.registration.field.honorCodeCheckbox.label',
    defaultMessage: 'We are requesting your consent to use your information for anonymised research '
      + 'aimed at improving the course and studying its impact. For more information, please see our '
      + '<link>privacy policy</link>.',
    description: 'Label for Honor Code checkbox',
  },
  hasAccount: {
    id: 'portal.views.registration.hasAccount.text',
    defaultMessage: 'Already have an account?',
    description: 'Text for already have an account',
  },
  loginLinkText: {
    id: 'portal.views.registration.login.link.text',
    defaultMessage: 'Log In',
    description: 'Text for login link',
  },
  validationUsernameEmptyError: {
    id: 'portal.views.registration.validation.username.empty.error',
    defaultMessage: 'Username must be between 2 and 30 characters',
    description: 'Error message for empty username field',
  },
  validationUsernameFormatError: {
    id: 'portal.views.registration.validation.username.format.error',
    defaultMessage: 'Usernames can only contain letters (A-Z, a-z), numerals (0-9), '
      + 'underscores (_), and hyphens (-). Usernames cannot contain spaces',
    description: 'Validation message that appears when username format is invalid',
  },
  validationPasswordRequiredError: {
    id: 'validation.password.required',
    defaultMessage: 'Enter your password',
    description: 'Shown when the password field is empty.',
  },
  validationPasswordTooShortError: {
    id: 'validation.password.tooShort',
    defaultMessage: 'Password must be at least 8 characters long',
    description: 'Shown when the password length is less than 8 characters.',
  },
  validationPasswordNoLetterError: {
    id: 'validation.password.noLetter',
    defaultMessage: 'Password must contain at least one letter',
    description: 'Shown when the password does not include any letters.',
  },
  validationPasswordNoNumberError: {
    id: 'validation.password.noNumber',
    defaultMessage: 'Password must contain at least one number',
    description: 'Shown when the password does not include any digits.',
  },
  validationPasswordNotMatchError: {
    id: 'portal.views.registration.validation.password.not.match.error',
    defaultMessage: 'The passwords do not match.',
    description: 'Password not match to confirm email',
  },
  validationEmailEmptyError: {
    id: 'portal.views.registration.validation.email.empty.error',
    defaultMessage: 'Enter your email',
    description: 'Error message for empty email field',
  },
  validationEmailFormatError: {
    id: 'portal.views.registration.validation.email.format.error',
    defaultMessage: 'Enter a valid email address',
    description: 'Validation error for invalid email address',
  },
  requestServerError: {
    id: 'portal.views.registration.request.server.error',
    defaultMessage: 'An error has occurred. Try refreshing the page, or check your internet connection.',
    description: 'Error message for internal server error.',
  },
  requestForbiddenError: {
    id: 'portal.views.registration.request.forbidden.error',
    defaultMessage: 'Too many failed registration attempts. Try again later.',
    description: 'Error message that appears when an anonymous user has made too many failed registration attempts',
  },
  requestDuplicateUsernameError: {
    id: 'portal.views.registration.request.duplicate.username.error',
    defaultMessage: 'It looks like this username is already taken.',
    description: 'Error message that appears when username is already taken',
  },
  requestDuplicateEmailError: {
    id: 'portal.views.registration.request.duplicate.email.error',
    defaultMessage: 'This email is already associated with an existing account',
    description: 'Error message that appears when email is already taken',
  },
  requestUnknownError: {
    id: 'portal.views.registration.request.unknown.error',
    defaultMessage: 'Please check your responses and try again.',
    description: 'Error message that appears on top of the form when empty form is submitted',
  },
  requestFailureHeader: {
    id: 'portal.views.registration.request.failure.header',
    defaultMessage: 'We couldn\'t create your account.',
    description: 'error message when registration failure.',
  },
  currentLanguageMessage: {
    id: 'portal.views.registration.alert.currentLanguage',
    defaultMessage: 'Important: Choose your course language carefully – after registration, the course '
      + 'language cannot be changed without losing your progress. Your current language selection '
      + 'is <bold>{language}</bold>. All learning materials will remain in this language, and videos '
      + 'will be in English with subtitles in this language. If you want to take the course in a different '
      + 'language, please change your language selection now in the upper right-hand corner. '
      + 'If you have any questions, please <link>contact us</link>.',
    description: 'Alert message that appears when user is on the registration page',
  },
});

export default messages;
